
export const VocsEditorScreenLabels = {
    it: {
        home: 'Home',
        functionalRoles: 'Ruoli Funzionali',
        organizationalRoles: 'Ruoli Organizzativi',
        businessUnitType: 'Business Unit Types',
        requisitesMainContexts: 'Contesti Principali dei Requisiti',
        saving: 'Salvataggio',
        savingNewData: 'Salvataggio dei dati in corso',
        error: 'OOOPS!!',
        info: 'Info',
        vocSavedCorrectly: 'Vocabolario salvato correttamente',
        delete: 'Elimina',
        loading: 'Caricamento...',
        addNewData: 'Aggiungi un nuovo dato',
        saveData: 'Salva i dati',
        data: 'Dati',
        code: 'Codice',
        name: 'Nome',
        icon: 'Icona',
        dataEntry: 'Data entry',
        verifier: 'Verificatore',
        validator: 'Validatore',
        order: 'Ordine',
        handHygieneDepartmentsCategory: 'Categorie di reparto igiene mani',
        handHygieneOperators: 'Operatori igiene mani',
        riskLevel: `Livello di rischio`,
        unauthorized: `Non disponi dei diritti necessari`,
        test: 'Test',
        hospitalRegimenTypes: 'Tipi di regime ospedaliero',
        dmsClassificationType: "Tipo di classificazione per dms",
        dmsValidationFlowTyps: "Tipologie flusso validazione dei file",
        specialtyCode: "Codice specialità",
        specialtyDescription: "Descrizione specialità",
        areaCode: "Codice area",
        areaDescription: "Descrizione area",
    },

    en: {
        home: 'Home',
        functionalRoles: 'Functional Roles',
        organizationalRoles: 'Organizational Roles',
        businessUnitType: 'Business Unit Types',
        requisitesMainContexts: 'Requisities Main Contexts',
        saving: 'Saving',
        savingNewData: 'Saving new data',
        error: 'OOOPS!!',
        info: 'Info',
        vocSavedCorrectly: 'Voc saved correctly',
        delete: 'Delete',
        loading: 'Loading...',
        addNewData: 'Add new data',
        saveData: 'Save this data',
        data: 'Data',
        code: 'Code',
        name: 'Name',
        icon: 'Icon',
        dataEntry: 'Data entry',
        verifier: 'Verifier',
        validator: 'Validator',
        test: 'Test',
        order: 'Order',
        handHygieneDepartmentsCategory: 'Hand Hygiene Departments Category',
        handHygieneOperators: 'Hand Hygiene Operators',
        riskLevel: `Risk Level`,
        unauthorized: `You don't have the necessary rights`,
        hospitalRegimenTypes: 'Hospital Regimen Types',
        dmsClassificationType: "Classifications types for dms",
        dmsValidationFlowTyps: "Validation flow types for dms",
        specialtyCode: "Specialty code",
        specialtyDescription: "Specialty description",
        areaCode: "Area code",
        areaDescription: "Area description"
    }
}; 